/* eslint-disable react/react-in-jsx-scope */

import { DataTable } from '@/components_v2/DataTable';
import {
  Alert,
  AlertIcon,
  Button,
  Flex,
  HStack,
  Input,
} from '@chakra-ui/react';
import React from 'react';
import { BiPlus } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';

import { useTemplateTasks } from './hooks';

export function TemplateTasks() {
  const {
    columns,
    data,
    isLoading,
    setSearchTerm,
    openForm,
  } = useTemplateTasks();
  const { t } = useTranslation();

  return (
    <Flex overflow="0" w="full" flexDir="column" gap="4">
      <Flex gap="4" flexDir="column">
        <Alert rounded="md" status="info">
          <AlertIcon />
          {t('registrations.template_alert_message')}
        </Alert>
        <HStack bg="gray.200" p="1.5" rounded="md" spacing={4}>
          <Input
            variant="filled"
            borderWidth="thin"
            borderColor="gray.300"
            placeholder={t('registrations.search')}
            w="xl"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button
            h="full"
            colorScheme="brand"
            rightIcon={<BiPlus />}
            onClick={() => openForm()}
            whiteSpace="break-spaces"
          >
            {t('registrations.create_new_template')}
          </Button>
        </HStack>
      </Flex>

      <Flex
        overflowY="auto"
        display="block"
        flex="1"
        rounded="md"
        borderWidth="thin"
      >
        <DataTable
          isLoading={isLoading}
          tableProps={{
            variant: 'striped',
            size: 'lg',
          }}
          headerProps={{
            h: 14,
            bg: 'white',
          }}
          columns={columns}
          data={data}
        />
      </Flex>
    </Flex>
  );
}
